function getRemainder(value: number, divisor = 6): number {
  return value % divisor; // returns 0, 1, 2, 3, 4, or 5
}

export { getRemainder };
